import addressAutofill from '../modules/addressAutofill';
import deliveryAddress from '../modules/deliveryAddress';
import discount from '../modules/discount';
import checkboxDiscount from '../modules/checkboxDiscount';

const $companyInput = $('.js-data-company');
const $emailInput = $('.js-email-field');
const $invoiceMethod = $('.js-payment[data-type="3"]');
const $newsletterToggle = $('.js-newsletter-toggle');
const $birthdateWrapper = $('#birthdate-wrapper');

function checkInvoiceMethod() {
  const val = $companyInput.val();
  $invoiceMethod.toggle(val !== '');
}

function connectEmailToCart(email) {
  $.ajax({
    url: '/api/cart',
    type: 'POST',
    data: {
      _method: 'PUT',
      email,
    },
  });
}

function checkNewsletterChecked() {
  if (!$birthdateWrapper.length || !$newsletterToggle.length) {
    return;
  }

  const checked = $newsletterToggle.is(':checked');

  $birthdateWrapper[checked ? 'removeAttr' : 'attr']('hidden', 'hidden');
}

const data = () => {
  addressAutofill();
  deliveryAddress.initialize();
  discount.initialize();
  checkboxDiscount.initialize();
  checkNewsletterChecked();

  $companyInput.on('keyup', () => {
    checkInvoiceMethod();
  });

  $emailInput.on('blur', (e) => {
    connectEmailToCart(e.currentTarget.value);
  });

  $newsletterToggle.on('change', () => {
    checkNewsletterChecked();
  });

  checkInvoiceMethod();
};

export default data;
